import request from '@/utils/request'

// 查询端口
export function fetchPlatformList(params) {
  return request({
    url: `/platform/platform`,
    method: 'get',
    params
  })
}
